import { createContext } from 'react';

export const CategoriesContext = createContext(null);
export const PagesContext = createContext(null);
export const SiteSettingsContext = createContext(null);
export const OriginalUrlContext = createContext(null);
